// Styles
import "./AppOverlay.scss";

// Mixins
import Colorable from "@mixins/colorable";
import Toggleable from "@mixins/toggleable";

// Utilities
import mixins from "@utils/mixins";

/* @vue/component */
export default mixins(Colorable, Toggleable).extend({
  name: "app-overlay",

  props: {
    absolute: Boolean,
    color: {
      type: String,
      default: "#000"
    },
    dark: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: [Number, String],
      default: 0.5
    },
    value: {
      default: true
    },
    zIndex: {
      type: [Number, String],
      default: 5
    }
  },

  computed: {
    __scrim() {
      const data = this.setBackgroundColor(this.color, {
        staticClass: "app-overlay__scrim",
        style: {
          opacity: this.computedOpacity
        }
      });

      return this.$createElement("div", data);
    },
    classes() {
      return {
        "app-overlay_absolute": this.absolute,
        "app-overlay_active": this.isActive
      };
    },
    computedOpacity() {
      return Number(this.isActive ? this.opacity : 0);
    },
    styles() {
      return {
        zIndex: this.zIndex
      };
    }
  },

  methods: {
    genContent() {
      return this.$createElement(
        "div",
        {
          staticClass: "app-overlay__content"
        },
        this.$slots.default
      );
    }
  },

  render(h) {
    const children = [this.__scrim];

    if (this.isActive) children.push(this.genContent());

    return h(
      "div",
      {
        staticClass: "app-overlay",
        class: this.classes,
        style: this.styles
      },
      children
    );
  }
});
